import * as Sentry from '@sentry/react'
import ReactDOM from 'react-dom/client'
// Fonte da marca, self-hosted (variável). Antes o app caía na fonte padrão do
// navegador — o `@import` estava comentado e `--font-nunito-sans` era
// auto-referente. Ver index.css.
import '@fontsource-variable/plus-jakarta-sans'
import App from './App'
import './index.css'
//import reportWebVitals from './reportWebVitals'

Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || 'development',
    tracesSampleRate: parseFloat(
        import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE || '0.1'
    ),
    enabled: !!import.meta.env.VITE_SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration()],
})

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
    <App />
)

/*if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker
            .register('/service-worker.js', { scope: '/' })
            .then(registration => {
                console.log(
                    'Service Worker registrado com sucesso:',
                    registration.scope
                )

                if (registration.installing) {
                    const installingWorker = registration.installing
                    installingWorker.addEventListener('statechange', () => {
                        if (installingWorker.state === 'activated') {
                            console.log('Service Worker ativado e pronto')
                            navigator.serviceWorker.ready.then(() => {
                                console.log(
                                    'Service Worker pronto para receber mensagens'
                                )
                            })
                        }
                    })
                } else if (registration.waiting) {
                    console.log('Service Worker aguardando ativação')
                } else if (registration.active) {
                    console.log('Service Worker já está ativo')
                    navigator.serviceWorker.ready.then(() => {
                        console.log(
                            'Service Worker pronto para receber mensagens'
                        )
                    })
                }
            })
            .catch(error => {
                console.log('Falha ao registrar Service Worker:', error)
            })
    })
}*/
